import CollapsibleTable, {
  CellComponentProps,
  CollapsibleRowProps,
  Order
} from './CollapsibleTable.component';

export type { CollapsibleRowProps, CellComponentProps, Order };
export default CollapsibleTable;
